import { Component } from '@angular/core';
import { AuthService } from '../../../../../../chat-common/src/lib/services/auth.service';

@Component({
  selector: 'app-desktop-footer',
  standalone: true,
  imports: [],
  templateUrl: './desktop-footer.component.html'
})
export class DesktopFooterComponent {
  constructor(private authService: AuthService) {}

  logout() {
    this.authService.signOut();
  }
}
